

import { Id, OrganizationContact } from '../types';
import { abibApi, tags, methods } from './';

const apiOrganizationSectorRelations = abibApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizationSectorRelations: builder.query<{ sector_ids: number[] }, { org_id: Id }>({
      query: ({ org_id }) => {
        return {
          url: `orgs/${org_id}/sectors`,
          method: methods.GET,
        };
      },
      providesTags: (result, error, { org_id }) => [{ type: tags.organization, org_id }],
      transformResponse: ({ data }, meta, arg) => ({ sector_ids: data }),
    }),
    updateOrganizationSectorRelations: builder.mutation<{ sector_ids: number[] }, { org_id: Id, sector_ids: number[] }>({
      query: ({ org_id, sector_ids }) => {
        return {
          url: `orgs/${org_id}/sectors`,
          method: methods.PUT,
          body: { sector_ids },
        };
      },
      invalidatesTags: (result, meta, { org_id }) => [{ type: tags.organization, org_id }],
      transformResponse: ({ data }, meta, arg) => ({ sector_ids: data }),
    }),
  }),
  overrideExisting: false,
})


// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetOrganizationSectorRelationsQuery,
  useLazyGetOrganizationSectorRelationsQuery,
  useUpdateOrganizationSectorRelationsMutation,
} = apiOrganizationSectorRelations;
